import React from "react";
import "../styles/TextBox.css";

export default function TextBox({ type = "text", ...props }) {
  if (type === "textarea") {
    return <textarea className="textbox" {...props} />;
  }
  return <input type={type} className="textbox" {...props} />;
}
